import state from './moduleBoletoState'
import mutations from './moduleBoletoMutations'
import actions from './moduleBoletoActions'
import getters from './moduleBoletoGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
